"use client";

import { Dialog, DialogContent } from "@/components/ui/dialog";

const Payment = ({ open, onOpenChange }) => {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent
                className="w-screen h-screen p-0"
            >
                <div id="cash-free-ornaz"></div>
            </DialogContent>
        </Dialog>
    )
}

export default Payment